export default __webpack_public_path__ + "static/17-158a76c24c836db97cfbb44217d51817.png";